<script setup>
import Input from 'dashboard/components-next/input/Input.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  holiday: { type: Object, required: true },
});

const emit = defineEmits(['remove']);
</script>

<template>
  <div class="flex flex-wrap gap-2 items-end">
    <Input
      v-model="holiday.date"
      type="date"
      :label="$t('INBOX_MGMT.WHATSAPP_CALLING.SETTINGS.HOLIDAY_DATE')"
      class="flex-1 min-w-36"
    />
    <Input
      v-model="holiday.name"
      :label="$t('INBOX_MGMT.WHATSAPP_CALLING.SETTINGS.HOLIDAY_NAME')"
      class="flex-1 min-w-36"
    />
    <Input
      v-model="holiday.openTime"
      type="time"
      :label="$t('INBOX_MGMT.WHATSAPP_CALLING.SETTINGS.HOLIDAY_OPEN')"
      class="w-28"
    />
    <Input
      v-model="holiday.closeTime"
      type="time"
      :label="$t('INBOX_MGMT.WHATSAPP_CALLING.SETTINGS.HOLIDAY_CLOSE')"
      class="w-28"
    />
    <Button
      faded
      slate
      icon="i-lucide-trash-2"
      class="mb-1"
      @click="emit('remove')"
    />
  </div>
</template>
